import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './Components/layout.js';
import Home from './Components/home.js';
import Contact from './Components/contact.js';
import About from './Components/about.js';
import Events from './Components/events.js';
import ErrorPage from './ErrorPage';
import Donations from './Components/donations.js';
import Testimonies from './Components/testimonies.js';
import Gallery from './Components/gallery.js';


function App() {
  return (
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="contact" element={<Contact />} />
          <Route path="about" element={<About />} />
          <Route path="events" element={<Events />} />
          <Route path="donations" element={<Donations />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="testimonies" element={<Testimonies />} />
          <Route path="*" element={<ErrorPage />} />
        </Route>
      </Routes>
  );
}

export default App;
